import { createStandardAction } from 'typesafe-actions';
export const socketSetupSuccess = createStandardAction('@socket/SOCKET_SETUP_SUCCESS')();
export const socketReconnect = createStandardAction('@socket/SOCKET_RECONNECT')(); // This action is coming from traffic control

export const receiveSocketConnection = createStandardAction('RECEIVE_SOCKET_CONNECTION')();